import React, { FunctionComponent } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import loaderSrc from '../../public/loader.svg'
import loaderBlackSrc from '../../public/loader-black.svg'

export interface Props {
  isLoading: boolean
  className?: string | null
  style?: React.CSSProperties
  black?: boolean
}

const Loader: FunctionComponent<Props> = ({
  isLoading = false,
  className = '',
  black = false,
  ...rest
}) => {
  const src = black ? loaderBlackSrc : loaderSrc
  return (
    <TransitionGroup>
      {isLoading && (
        <CSSTransition
          classNames="loader-animation"
          timeout={{
            enter: 200,
            exit: 300,
          }}
        >
          <img src={src} className={`loader ${className}`} {...rest} />
        </CSSTransition>
      )}
    </TransitionGroup>
  )
}

export default Loader
